import WalletPaymentMethod from './WalletPaymentMethod'

export default WalletPaymentMethod
